/*
 *   Copyright (c) 2021 Novumare Technologies
 *   All rights reserved.
 */
import history from '../history';
import axios from "axios"
import { LOGIN, LOGOUT } from './types';
import { API } from './api';

export const login = (username, password) => {
    return async dispatch => {
        const response = await axios.post(API + '/users/auth/', { username, password });
        if (typeof response.data === 'string') {
            localStorage.setItem("userToken", JSON.stringify({ username: username, token: response.data, auth: true }));
            history.push('/admin');
        }
        dispatch({
            type: LOGIN
        });
    }
}

export const isLogged = (history) => {
    return dispatch => {
        const user = JSON.parse(localStorage.getItem("userToken"));
        const pageURL = history.location.pathname;
        if (user.auth) {
            dispatch({
                type: LOGIN
            });
            pageURL === '/auth/login' ? history.push('/admin/dashboard') : history.push(pageURL)
        } else {
            history.push('/auth/login');
        }
    }
}

export const logout = () => {
    return dispatch => {
        localStorage.removeItem("userToken");
        localStorage.setItem("userToken", JSON.stringify({ auth: false }));
        dispatch({
            type: LOGOUT
        });
        history.push('/');
    }
}